import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FlexByRow, XDivider, HalfScreen, YDivider } from '../../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../../AppControl/RoutePage'
import { ClearButton, SaveButton } from '../../../../irmlib/src/components/FormControls'
import { useFormPageHandler, useSearchParams } from '../../../../irmlib/src/hooks'
import * as regx from '../../../../irmlib/src/components/FormControls'
import SearchIcon from '../../../Icons/SearchIcon'
import { TextField, IconButton, InputAdornment, Paper, Chip } from '../../../../irmlib/src/components/Controls'
import { userRoleUser } from '../../../../common/constants'
import TemplateSearchTabledata from './TemplateSearchTabledata'
import { FilterList } from '../../../../irmlib/src/icons'
import * as constants from '../../../../irmlib/src/common/constants'
import { SearchContainer, SearchTextContainer } from '../../../../styles'
import { useTranslation } from 'react-i18next'

const formTemplate = [
  {
    label: '',
    fieldKey: 'Search',
    isRequired: true,
    regx: regx.alphaRegex,
    regxError: regx.alphaRegexError
  },
]

const Buttons = props =>
  <>
    <ClearButton clearLabel='forms.Reset'arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array
}

const VerticalDivider = () =>
  <YDivider height='8px' />

const getService = async () => {
  const getObject = {
    obj: {

    }
  }
  return Promise.resolve(getObject)
}

const TemplateSearchTable = (props) => {
  const { t } = useTranslation()
  const value = props.dataSearch
  const refLocalBusyCursor = useRef(null)
  const searchParams = useSearchParams()
  const [TextValue, setTextValue] = React.useState(null)
  const statusNavParam = searchParams?.get('status') || constants.defaultSelect
  const [chipData, setChipData] = React.useState(!statusNavParam ? [] : [{ key: 1, label: statusNavParam }])
  const [val, Setval] = React.useState({ 
    country: value.country, 
    wms: value.wms, 
    accountLevel1: value.accountLevel1.toUpperCase(),
    accountLevel2: value.accountLevel2.toUpperCase(),
    accountLevel3: value.accountLevel3.toUpperCase(),
    dateCreatedFrom: value.dateCreatedFrom,
    templateType: value.templateType,
    templateName: value.templateName,
    dateCreatedTo: value.dateCreatedTo
  })
  useEffect(() => {
    const dataFilter = [
      { key: 1, label: value.country },
      { key: 2, label: value.wms },
      { key: 3, label: value.accountLevel1.toUpperCase() },
      { key: 4, label: value.accountLevel2.toUpperCase() },
      { key: 5, label: value.accountLevel3.toUpperCase() },
      { key: 6, label: value.dateCreatedFrom },
      { key: 7, label: value.templateType },
      { key: 8, label: value.templateName },
      { key: 9, label: value.dateCreatedTo }

    ]
    setChipData(dataFilter)
  }, [value])

  useEffect(() => {
    Setval(
      {
        country: value.country,
        wms: value.wms,
        accountLevel1: value.accountLevel1,
        accountLevel2: value.accountLevel2,
        accountLevel3: value.accountLevel3,
        dateCreatedFrom: value.dateCreatedFrom,
        templateType: value.templateType,
        templateName: value.templateName,
        dateCreatedTo: value.dateCreatedTo
      }
    )
  }, [value])


  const userVal = userRoleUser

  const [data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const setFilterValues = (value) => {
    try {
      const datas = { 
        country: value[0].label,
        wms: value[1].label, 
        accountLevel1: value[2].label, 
        accountLevel2: value[3].label, 
        accountLevel3: value[4].label, 
        dateCreatedFrom: value[5].label, 
        templateType: value[6].label, 
        templateName: value[7].label, 
        dateCreatedTo: value[8].label, 
      }

      Setval(datas)
    } catch (err) {
    }
  }

  const handleChipDelete = (chipToDelete) => () => {
    const chips = [...chipData]

    if (val.country === chipToDelete.label) {
      val.country = constants.defaultSelect
      chips[0].label = constants.defaultSelect
    }
    if (val.wms === chipToDelete.label) {
      val.wms = constants.defaultSelect
      chips[1].label = constants.defaultSelect
    }
    if (val.accountLevel1 === chipToDelete.label) {
      val.accountLevel1 = constants.defaultForAccountLevel
      chips[2].label = constants.defaultForAccountLevel
    }
    if (val.accountLevel2 === chipToDelete.label) {
      val.customer = constants.accountLevel2
      chips[3].label = constants.defaultForAccountLevel
    }
    if (val.accountLevel3 === chipToDelete.label) {
      val.accountLevel3 = constants.accountLevel3
      chips[4].label = constants.defaultForAccountLevel
    }
    if (val.dateCreatedFrom === chipToDelete.label) {
      val.dateCreatedFrom = constants.defaultSelect
      chips[5].label = constants.defaultSelect
    }
    if (val.templateType === chipToDelete.label) {
      val.templateType = constants.defaultSelect
      chips[6].label = constants.defaultSelect
    }
    if (val.templateName === chipToDelete.label) {
      val.templateNAme = constants.defaultSelect
      chips[7].label = constants.defaultSelect
    }
   
    if (val.dateCreatedTo === chipToDelete.label) {
      val.dateCreatedTo = constants.defaultSelect
      chips[8].label = constants.defaultSelect
    }
    
    Setval(val)
    setChipData(chips)
    setFilterValues(chips)
  }
  
  const ab = (value) => {
    setTextValue(value)
  }

  const dataFilter = (value) => {
    props.dataRecieved(value)
  }
  

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.templateManagement'
      subTitle='routeTitles.viewTemplate1'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <Paper
                elevation={0}
                component="ul"
              > 
                {chipData.map((data) => {
                  if (data.label !== [constants.defaultChipLabel] && data.label !== constants.defaultSelect && data.label !== constants.defaultForAccountLevel) {
                    return (
                      <>
                        <Chip
                          color="primary"
                          variant="outlined"
                          id={`templateSearch_chipView_${data.label}`}
                          label={!t(`templateTypeObj.${data.label}`).match('templateTypeObj') ? t(`templateTypeObj.${data.label}`) : data.label}
                          onDelete={data.label === constants.react ? undefined : handleChipDelete(data)}
                          noTranslate
                        />
                        <XDivider width='10px' />
                      </>
                    )
                  } else {
                    return null
                  }
                })}
              </Paper>
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
        <HalfScreen>
          <FlexByRow>
            <SearchContainer>
              <SearchTextContainer>
                <VerticalDivider />
                <TextField
                  id={'templateSearch_search'} 
                  onChange={ab}
                  data={data}
                  noTranslate={true}
                  endAdornment={
                    <InputAdornment position='end'>
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </SearchTextContainer>
              <IconButton
                id={'templateSearch_filterButton'} 
                variant="contained"
                onClick={() => props.onClickFilter(props.dataSearch)}
              >
                <FilterList fontSize='medium' />
              </IconButton>
            </SearchContainer>
          </FlexByRow>
        </HalfScreen>
      </FlexByRow>
      <TemplateSearchTabledata DataSearch={TextValue} FilterData={val} Jobs={userVal} dataFilter={dataFilter} />
    </MainRouteSubRoutePage>
  )
}
TemplateSearchTable.propTypes = {
  dataSearch: PropTypes.string,
  onClickFilter: PropTypes.func,
  dataRecieved: PropTypes.func,
}

export default TemplateSearchTable
